import {
  Box,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { restartProductManufacturing } from "../../../slices/manufacturer";
import { useEffect, useState } from "react";
import { fetchRemanufacturingReasonDropDown } from "../../../slices/remanufacturingReasons";
import FormikControl from "../FormikControl";
import { selectCurrentCycle, selectV2VCycle } from "../../../slices/common";
import { volumnBagList, selectDynamicBagDropDown } from "../../../slices/manufacturer";
import {getNextCycleName} from "../../../../utils/utils"

const initialValues = {
  restart_option: "1", // default selection
  blood_amount: [],
  reason:''
};



const typeOptions = [
  { value: "2", label: "Restart Apheresis " },
  { value: "1", label: "Use Cryopreserve Blood" },
]

const RestartManufacturingForm = (
  formProps
) => {
  const dispatch = useDispatch();
  const [reasons, setReasons] = useState([])
  // const { id, feasibility_id } = useParams();
  const currentCycle = useSelector(selectCurrentCycle)
  const bagDropDown = useSelector(selectDynamicBagDropDown)
  const V2VCycle = useSelector(selectV2VCycle);
  
  const validationSchema = Yup.object().shape({
  restart_option: Yup.string().required("Please select an option to continue"),
  reason: Yup.string().required("Please select an option to continue"),
  blood_amount: Yup.array().when("restart_option", {
    is: "1",
    then: (schema) => schema.required('Bags is required')
     .min(1, "Select at least one bag")
 })
});

  const fetchBagsList = async(id) =>{
     try {
        await dispatch(volumnBagList(id)).unwrap();
      } catch (err) {
        console.error("Error restarting manufacturing:", err);
      }
  }

  const handleSubmit = async (values) => {
    try {
      // Prepare API payload with the selected restart option
      const payload = {
        subject_id: formProps?.subject_id,
        feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
        product_manufacturing_stages_id: currentCycle?.product_manufacturing_id,        
        qr_code_generated_id: formProps?.qr_code_generated_id,
        restart_type: values.restart_option, // Include the selected option
        reason: values.reason,
        ...(values.restart_option =='2' && {cycle: currentCycle?.cycle}),
       ...(values.restart_option =='1' && {bags_id: values.blood_amount, cycle_no: getNextCycleName(V2VCycle)})
      };
      // Hit the restart API with the chosen option
      const res = await dispatch(restartProductManufacturing(payload)).unwrap();

      if (res?.status === 200) {
        formProps.handleFormSubmit();
      }
    } catch (err) {
      console.error("Error restarting manufacturing:", err);
    }
  };

  const getAllReason = async () => {
    try {
      const res = await dispatch(fetchRemanufacturingReasonDropDown()).unwrap()
      if (res.status == 200) {
        const resReasons = res.data?.items?.map(op => { return { value: op.id, label: op.name } })
        setReasons(resReasons)
      }
    } catch (err) {
      console.error(err);

    }
  }

  useEffect(() => {
    getAllReason()
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const formOptions = [
    {
      label: 'Remanufacturing reason',
      required: true,
      type: 'select',
      name: 'reason',
      options: reasons,
    },
    {
        label: 'Note',
    },
    {
      label: 'Pick an option to continue',
      type: 'radio', // assuming it's a select input
      name: 'restart_option',
      options: typeOptions,
      required: true,
      placeholder: 'Select mode',
    },
     ...(formik.values?.restart_option == 1
      ? [
        {
          label: 'Required Bags',
          type: 'select',
          name: 'blood_amount',
          multiple:true,
          options: bagDropDown,
          placeholder: 'Select Bags',
          required: true,
          extraContent:'ml'
        },
      ]
      : []),
  ];

    useEffect(() =>{
    fetchBagsList(currentCycle?.feasibility_assessments_id)
    },[currentCycle?.feasibility_assessments_id])
  

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            props?.label == 'Note' ?
            (<Grid key={key} item xs={12}>
           
            <p className="text-[#FB9D2C] text-sm mt-1">
              <span className="font-semibold">Note:</span> If the required amount of blood exceeds the remaining cryopreserved blood, 
              select <span className="font-semibold">‘Restart Apheresis’</span>.
            </p>
            </Grid>)
              :
            (<Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>)
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              // loading={isLoading}
              sx={{ backgroundColor: "#3571FF" }}
            >
              Restart Manufacturing
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default RestartManufacturingForm;
